<img (click)="closeClicked.emit()" class="close-button" [src]="'assets/icons/grey/X.svg'" alt="Close" i18n-alt />
